import { ReactMarkdownProps } from 'react-markdown/lib/complex-types';
import styles from './CustomLink.module.scss';

interface CustomLinkProps extends ReactMarkdownProps {
  href?: string;
}

export const CustomLink = (props: CustomLinkProps) => {
  const isAnchor = props.href?.startsWith('#');

  if (isAnchor) {
    return <span>{props.children}</span>;
  }

  return (
    <a className={styles.root} target="_blank" rel="noreferrer" {...props}>
      {props.children}
    </a>
  );
};
